// @ts-nocheck

import * as Types from '../../../../../../../graphql/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import { gql } from '@apollo/client';
export type GetRateCardsQueryVariables = Types.Exact<{
  query: Types.RateCardQueryModelInput;
  page?: Types.InputMaybe<Types.PageModelInput>;
  sort?: Types.InputMaybe<
    Array<Types.InputMaybe<Types.RateCardSortModelInput>> | Types.InputMaybe<Types.RateCardSortModelInput>
  >;
}>;

export type GetRateCardsQuery = {
  rateCards: { totalCount?: number | null; items?: Array<RateCardDataFragment | null> | null };
};

export type RateCardDataFragment = {
  uid: string;
  name?: string | null;
  referenceId?: string | null;
  referenceCode?: string | null;
  status?: Types.StatusModel | null;
  jobProfile?: { uid: string; name?: string | null } | null;
  businessSiteOverrides?: Array<{ uid: string; name?: string | null } | null> | null;
  remoteWorkAddress?: { uid: string; countryCode?: string | null } | null;
  supplier?: { uid: string; name?: string | null } | null;
  rates?: {
    totalCount?: number | null;
    items?: Array<{
      name?: string | null;
      code?: string | null;
      type?: Types.ComplexRateTypeModel | null;
      invoiceMapping?: Types.InvoiceMappingModel | null;
      rateType?: Types.RateTypeModel | null;
      formula?: { baseRateCode?: string | null; multiplier?: number | null } | null;
      static?: { amount?: string | null; currency?: string | null; frequency?: Types.RatePeriodModel | null } | null;
    } | null> | null;
  } | null;
};

export const RateCardDataFragmentDoc = gql`
    fragment RateCardData on RateCardModel {
  uid
  name
  referenceId
  referenceCode
  status
  jobProfile {
    uid
    name
  }
  businessSiteOverrides {
    uid
    name
  }
  remoteWorkAddress {
    uid
    countryCode
  }
  supplier {
    uid
    name
  }
  rates {
    items {
      name
      code
      type
      invoiceMapping
      formula {
        baseRateCode
        multiplier
      }
      rateType
      static {
        amount
        currency
        frequency
      }
    }
    totalCount
  }
}
    ` as unknown as DocumentNode<RateCardDataFragment, unknown>;
export const GetRateCardsDocument = gql`
    query GetRateCards($query: RateCardQueryModelInput!, $page: PageModelInput, $sort: [RateCardSortModelInput]) {
  rateCards(query: $query, page: $page, sort: $sort) {
    totalCount
    items {
      ...RateCardData
    }
  }
}
    ${RateCardDataFragmentDoc}` as unknown as DocumentNode<GetRateCardsQuery, GetRateCardsQueryVariables>;
